"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullPageLoader = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FullPageLoader = () => {
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    color: "inherit",
    size: 100
  }));
};
exports.FullPageLoader = FullPageLoader;